import { render } from "./AppRightMenu.vue?vue&type=template&id=6c35009f"
import script from "./AppRightMenu.vue?vue&type=script&lang=js"
export * from "./AppRightMenu.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__